import * as React from "react";
import { forwardRef, memo } from "react";
const SvgNoPaddingFilledInfoIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 5, r: 4.5, fill: "white", stroke: "#1F3B44" }), /* @__PURE__ */ React.createElement("path", { d: "M5 3V5.5", stroke: "#1F3B44", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 7.375, r: 0.5, fill: "#1F3B44" }));
const ForwardRef = forwardRef(SvgNoPaddingFilledInfoIcon);
const Memo = memo(ForwardRef);
export default Memo;
